module.exports = __webpack_public_path__ + "3e331b3c4622631e097b545aa8476087.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/virtual-sports/assets/vfwc.png
// module id = 1783
// module chunks = 2